const PRODUCTION_API_BASE_URL = 'https://api.apiruntime.dev';

export function resolveApiBaseUrl(): string {
  const configured = String(import.meta.env.VITE_API_BASE_URL || '').trim();
  if (configured) {
    return configured;
  }

  return PRODUCTION_API_BASE_URL;
}

export const API_BASE_URL = resolveApiBaseUrl();
